import { Component, Input, OnDestroy, OnInit,  } from '@angular/core';

import { ApiAlarmLogsService } from '../../services/http/api-alarm-logs.service';
import { AlarmLog } from 'src/app/core/models/logs/alarm-log.model';
import { PaginationData } from 'src/app/core/models/pagination-data.model';
import { SsFilterSort } from 'src/app/core/models/ss-filter-sort.model';
import { Controller } from 'src/app/core/models/controller.model';
import { UserSettingsService } from 'src/app/shared/services/user-settings.service';
import { AlertController, PopoverController } from '@ionic/angular';
import { CustomTranslatePipe } from 'src/app/shared/pipes/custom-translate.pipe';
import { DemoModeData, DemoModeService } from 'src/app/shared/services/demo-mode.service';
import { DEMO_MODE } from 'src/environments/environment';
import { AlarmTypePopoverComponent } from '../../components/alarm-type-popover/alarm-type-popover.component';
import { AlarmSubscriptionsService } from 'src/app/modules/alarms/services/alarm-subscriptions.service';
import { AlarmType } from 'src/app/core/models/alarms/alarm-type.model';
import { ApiAlarmsService } from 'src/app/modules/alarms/services/http/api-alarms.service';
import { Subject, Subscription } from 'rxjs';

@Component({
  selector: 'app-alarm-logs',
  templateUrl: './alarm-logs.component.html',
  styleUrls: ['./alarm-logs.component.scss']
})
export class AlarmLogsComponent implements OnInit, OnDestroy {

  @Input() controllers: Controller[];
  @Input() singleRoom: boolean;
  mainController: Controller;
  alarmLogData: AlarmLog[]  = [];
  paginationData: PaginationData = new PaginationData();
  filtersDropdownOpened = false;

  // Column widths for the logs table. Edit these to taste.
  // Order: Timestamp, Description, User confirmed, Confirmation text, Confirmation time.
  // 'auto' = rigid (sized to content + min-width in SCSS); % = flexible/truncating.
  columnWidths: string[] = ['auto', '40%', '25%', '35%', 'auto'];

  queryParams = {
    pageNumber: 1,
    pageSize: 50
  };
  requestBody: SsFilterSort = new SsFilterSort();
  loading = false;
  language: string;

  alarmTypesSubscription: Subscription;
  downloadInProgress = false;
  alarmTypes: AlarmType[];
  selectedAlarmTypes: number[] = [];
  alarmTypesSubject = new Subject<number[]>();

  constructor(private apiAlarmLogsService: ApiAlarmLogsService,
              private userLanguageService: UserSettingsService,
              private alertController: AlertController,
              private pipe: CustomTranslatePipe,
              private alarmSubscriptionsService: AlarmSubscriptionsService,
              private apiAlarmsService: ApiAlarmsService,
              private popoverController: PopoverController,
              private demoModeService: DemoModeService) { }

  ngOnInit(): void {
    this.getAlarmTypes();

    //subscribe to the filtering data we are getting from the popover component
    this.alarmTypesSubject.subscribe( value => {
      this.selectedAlarmTypes = value;
    })

    if (DEMO_MODE) {
      this.demoModeService.getData().subscribe( (value:DemoModeData) => {
        this.paginationData = value.Pagination
        this.alarmLogData = value.AlarmLog

        if (this.singleRoom) {
          this.alarmLogData = this.alarmLogData.filter (data => +data.controllerDesignation.split('/')[2] == +this.mainController.zone)
        }
        this.loading = false
      })
}
    if (this.singleRoom) {
      this.mainController = Controller.getMainController(this.controllers)
      const designationFilter: string[] = this.controllers.map((cont: Controller)=> {
        return cont.designation
      })
      this.requestBody.controllerDesignations = designationFilter;
    }
    this.language = this.userLanguageService.getLanguage()

    this.onSubmit(1, 'DSC|TIME');
  }

  getAlarmTypes() {
    this.loading = true;
    this.alarmTypes = this.alarmSubscriptionsService.getAlarmTypes();
    this.apiAlarmsService.getAlarmTypes().subscribe();
    this.alarmTypesSubscription = this.alarmSubscriptionsService.alarmTypesChanged.subscribe(() => {
      this.alarmTypes = this.alarmSubscriptionsService.getAlarmTypes();
      this.loading = false;
    });
  }


  controllerChanged(controller: Controller) {
    this.mainController = controller;
    this.onSubmit(1, 'DSC|TIME');
  }


  onSubmit(pageNumber: number = 1, pageSort?: string) {
    this.loading = true;
    if (DEMO_MODE) {
      this.loading = false
    }
    if (pageSort) {
       this.requestBody.sorting = pageSort;
      }


    this.queryParams.pageNumber = pageNumber;
    this.apiAlarmLogsService.getAlarmLogs(this.requestBody, this.queryParams).subscribe(resp => {
      this.paginationData = JSON.parse(resp.headers.get('X-Pagination'));
      this.alarmLogData = resp.body;
      this.loading = false;
    });
  }

  onSort(sortBy: string) {
    if (this.requestBody.sorting === 'ASC|' + sortBy) {
      this.requestBody.sorting = 'DSC|' + sortBy;
    } else {
      this.requestBody.sorting = 'ASC|' + sortBy;
    }
    this.onSubmit(this.queryParams.pageNumber);
  }

  searchFilterReady(searchFilter: string) {
    this.requestBody.filtering = searchFilter;
    this.onSubmit();
  }

  async openAlarmTypesPopover(ev: any) {
    this.filtersDropdownOpened =! this.filtersDropdownOpened;
    const popover = await this.popoverController.create({
      component: AlarmTypePopoverComponent,
      cssClass: 'alarm-type-popover',
      event: ev,
      backdropDismiss: true,
      componentProps: {
        alarmTypes: this.alarmTypes,
        selectedAlarmTypes: this.selectedAlarmTypes,
        alarmTypesSubject: this.alarmTypesSubject
      }
    });
    await popover.present();

    popover.onDidDismiss().then( () => {
      this.requestBody.types = this.selectedAlarmTypes;
      this.onSubmit();
      this.filtersDropdownOpened = false;
    })
  }

  async confirmDownload(fileType: string) {
    let message = '';
    if (fileType === 'PDF') {
      message = this.pipe.transform('Maximum event number is 5000')
    }
    const alert = await this.alertController.create({
      header: this.pipe.transform('Do you want to download ') + fileType + this.pipe.transform(' file?'),
      message: message,
      buttons: [ {
        text: this.pipe.transform('Cancel'),
        role: 'cancel',
      },
        {
          text: this.pipe.transform('Accept'),
          handler: () => {
            this.downloadInProgress = true;
            if (fileType === 'CSV') {
              this.exportToCSV()
            } else if (fileType === 'PDF') {
              this.exportToPDF()
            }

          }
        }
      ],
    });
    await alert.present();

  }

  exportToCSV() {
    this.apiAlarmLogsService.exportLogToCSV(this.requestBody, this.language).subscribe( response => {
      let binaryData = [];
      binaryData.push(response.body);
      let downloadLink = document.createElement('a');
      const objectURL = window.URL.createObjectURL(new Blob(binaryData, { type: 'blob' }));
      downloadLink.href = objectURL
      downloadLink.setAttribute('download', 'AlarmLogExport.csv');
      document.body.appendChild(downloadLink);
      downloadLink.click();
      URL.revokeObjectURL(objectURL);
      this.downloadInProgress = false;
    })
  }

  exportToPDF() {
    this.apiAlarmLogsService.exportLogToPDF(this.requestBody, this.language).subscribe( response => {
      let binaryData = [];
      binaryData.push(response.body);
      let downloadLink = document.createElement('a');
      const objectURL = window.URL.createObjectURL(new Blob(binaryData, { type: 'blob' }));
      downloadLink.href = objectURL
      downloadLink.setAttribute('download', 'AlarmLogExport.pdf');
      document.body.appendChild(downloadLink);
      downloadLink.click();
      URL.revokeObjectURL(objectURL);
      this.downloadInProgress = false;
    })
  }


  setDateTimeFromTo(selectedDateTime: Date[]) {
    this.requestBody.dateTimeFrom = selectedDateTime[0];
    this.requestBody.dateTimeTo = selectedDateTime[1];
    this.onSubmit();
  }

  ngOnDestroy() {
    if (this.alarmTypesSubscription) {
      this.alarmTypesSubscription.unsubscribe();
    }
  }

}
